import { createPrecipSampler, precipClass } from "@divespots/contracts";
import type { PrecipField } from "@divespots/contracts";
import { hourStart } from "./time.ts";

export interface PrecipReading {
  /** Start of the hour [H, H+1) the value belongs to. */
  fromMs: number;
  /** One decimal, mm per hour (the hour's sum). */
  mm: number;
  /** Below 0.1 mm/h: reported as no precipitation, never as a number. */
  dry: boolean;
}

/** Precipitation at a point for the hour containing `tMs`; null where the model has no sum (never "dry"). */
export function readPrecip(
  field: Pick<PrecipField, "grid" | "times" | "p">,
  lat: number,
  lon: number,
  tMs: number,
): PrecipReading | null {
  const v = createPrecipSampler(field)(lon, lat, tMs);
  if (v === null) return null;
  return { fromMs: hourStart(tMs), mm: Math.round(v * 10) / 10, dry: precipClass(v) < 0 };
}
